<template>
  <div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      style="backdrop-filter: blur(6px)"
      id="modalAggPagos"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div
          class="modal-content text-center"
          style="width: 100%; max-width: 100%"
        >
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <h3 class="text-success font-weight-bold">
                AGREGAR PAGO AL CARGO &nbsp;&nbsp;
                <i class="fas fa-folder-open fa-2x"></i>
              </h3>
              <br />
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label>Forma de pago</label>
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="apl_current.tipo_abono"
                      @change="refreshAbonos()"
                    >
                      <option
                        class="text-dark"
                        v-for="(c, key) in tipos_abonos"
                        :value="c.id"
                        :key="key"
                      >
                        {{ c.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          apl_current.errors.valor_total &&
                          apl_current.errors.valor_total.length > 0,
                      }"
                      >Abonar</label
                    >
                    <input
                      v-model="apl_current.valor_total"
                      class="form-control"
                      placeholder="Valor"
                      v-bind:class="{
                        'is-invalid':
                          apl_current.errors && apl_current.errors.valor_total,
                      }"
                      type="number"
                      step="0.05"
                    />
                    <small
                      v-if="
                        apl_current.errors && apl_current.errors.valor_total
                      "
                      class="form-text text-danger"
                      >{{ apl_current.errors.valor_total }}</small
                    >
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          apl_current.errors.abono_e &&
                          apl_current.errors.abono_e.length > 0,
                      }"
                      >Abono a aplicar</label
                    >
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="apl_current.abono_e"
                    >
                      <option
                        class="text-dark"
                        v-for="(c, key) in abonos"
                        :value="c.id"
                        :key="key"
                      >
                        Abono #{{ c.documento }} // Disponible:
                        {{ c.total_pendiente }}
                      </option>
                    </select>
                    <small
                      v-if="apl_current.errors && apl_current.errors.abono_e"
                      class="form-text text-danger"
                      >{{ apl_current.errors.abono_e }}</small
                    >
                  </div>
                  <div class="row">
                    <h6 class="post-title"></h6>
                    &nbsp; &nbsp;
                    <button
                      type="button"
                      class="btn btn-lg btn-outline-success btn-block"
                      @click="agregarAbono()"
                    >
                      <i class="far fa-save"></i> Agregar abono
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  props: ["current", "tipos_abonos"],
  components: {
    UsuarioEnTablaComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      apl_current: {
        tipo_abono: null,
        abono_e: null,
        valor_total: null,
        errors: {
          tipo_abono: null,
          abono_e: null,
          valor_total: null,
        },
      },
      abonos: [],
      current_filter: {},
      dataTabla: [],
      mostrarRefresh: false,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    agregarAbono() {
      let self = this;
      let params = self.apl_current;
      DynamicService.postAction(
        "cxp",
        "cargos",
        self.current.id,
        "aplicar_abono",
        params
      )
        .then((res) => {
          Notifications.toast.success(
            "Agregar abono",
            "Realizado correctamente"
          );
          $("#modalAggPagos").modal("hide");
          self.$emit("refreshCargo");
          self.apl_current = {
            tipo_abono: null,
            abono_e: null,
            valor_total: null,
            errors: {
              tipo_abono: null,
              abono_e: null,
              valor_total: null,
            },
          };
        })
        .catch((error) => {
          console.log(error.response.data);
          self.apl_current.errors = error.response.data;
          self.$emit("refresh");
          self.refreshAbonos();
        });
    },
    refreshAbonos() {
      let self = this;
      let params = {
        con_saldo_pendiente: "True",
        tipo_abono: self.apl_current.tipo_abono,
        proveedor: self.current.proveedor.codigo,
      };
      DynamicService.fetch("cxp", "abonos", params).then((res) => {
        self.abonos = res.data;
      });
    },
    refreshAbonos() {
      let self = this;
      let params = {
        con_saldo_pendiente: "True",
        tipo_abono: self.apl_current.tipo_abono,
        proveedor: self.current.proveedor.codigo,
      };
      DynamicService.fetch("cxp", "abonos", params).then((res) => {
        self.abonos = res.data;
      });
    },
    cleanCurrentDefault() {
      let self = this;
      self.current = {
        errors: [],
        valor_iva: "",
      };
    },
    calcularImpuesto() {
      let self = this;
      DynamicService.getAction(
        "cxp",
        "cargos",
        self.current_.id,
        "calcular_iva_facturas_servicios",
        self.current
      ).then((res) => {
        self.current.valor_iva = res.data.valor_iva;
      });
    },
    guardar() {
      let self = this;
      Notifications.alert.confirm(
        "Agregar factura a cargo",
        "¿Esta seguro(a)?",
        "",
        function () {
          if (self.current.fecha_documento) {
            self.current.fecha_documento = moment(
              self.current.fecha_documento
            ).format("YYYY-MM-DD");
          }
          self.current.bien_servicio = self.current_.bien_servicio;
          DynamicService.postAction(
            "cxp",
            "cargos",
            self.current_.id,
            "agregar_modificar_factura_servicio",
            self.current
          )
            .then((res) => {
              Notifications.alert.success(
                "Generar cargo por entrada de compra",
                "Generado correctamente"
              );
              $("#modalentradas").modal("hide");
              self.$emit("refreshCargo");
              self.cleanCurrentDefault();
            })
            .catch((err) => {
              self.current.errors = err.response.data;
              if (err.response.data.detail) {
                Notifications.alert.error(
                  "Generar cargo por entrada de compra",
                  err.response.data.detail
                );
              }
            });
        }
      );
    },
    defaultData() {
      let self = this;
      self.current_filter = {};
      self.dataTabla = "";
    },
    refreshData() {
      let self = this;
      if (self.current_filter.fecha) {
        self.current_filter.fecha_documento = self.current_filter.fecha;
      }
      DynamicService.getActionList(
        "inv",
        "ent_compra",
        "entrada_pendientes_generar_cxp",
        self.current_filter
      ).then((response) => {
        self.dataTabla = response.data;
      });
    },
    rowClick(current) {
      let self = this;
      Notifications.alert.confirm(
        "Agregar factura a cargo",
        "¿Esta seguro(a)?",
        "",
        function () {
          console.log(self.cargo.id);
          DynamicService.getActionList(
            "wms",
            "recepcion",
            "generar_cargo_cxp",
            {
              id: current.entrada_por_compra_e,
              cargo: self.cargo.id,
            }
          )
            .then((res) => {
              Notifications.alert.success(
                "Generar cargo por entrada de compra",
                "Generado correctamente"
              );
              $("#modalentradas").modal("hide");
              self.$emit("refreshCargo");
            })
            .catch((err) => {
              Notifications.alert.error(
                "Generar cargo por entrada de compra",
                err.response.data.detail
              );
            });
        }
      );
    },
  },
};
</script>
